import { render, staticRenderFns } from "./Prerequisites.vue?vue&type=template&id=15fe1cce&scoped=true&"
import script from "./Prerequisites.vue?vue&type=script&lang=js&"
export * from "./Prerequisites.vue?vue&type=script&lang=js&"
import style0 from "./Prerequisites.vue?vue&type=style&index=0&id=15fe1cce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fe1cce",
  null
  
)

export default component.exports